import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import RandomContent from '../Components/RandomContent';
import ConversionActions from '../Common/ConversionActions';
import { minifyHTML } from '../Conversion/Minifiers';
import { GetRandomBlogPost, GetPageContentBySlug } from '../services/apiservice';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { htmlMinifierFAQ } from '../Seo/faqSchemas';

const HtmlMinifier = () => {
  const [inputData, setInputData] = useState('');
  const [outputData, setOutputData] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });
  const [tabSpace, setTabSpace] = useState(2);
  const [randomPost, setRandomPost] = useState('');
  const [loadingPost, setLoadingPost] = useState(true);
  const [pageContent, setpageContent] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const handleBlogClick = () => navigate('/blog/:paramlink');

  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    setInputData('');
    setOutputData('');
    setIsError(false);
    fetchRandomPost();
    GetPageContent();
  }, []);

  const handleConversion = () => {
    try {
      const { minified, isError } = minifyHTML(inputData);
      setOutputData(minified);
      setIsError(isError);
    } catch (error) {
      setOutputData('Error while minifying HTML');
      setIsError(true);
    }
  };

  const fetchRandomPost = async () => {
    setLoadingPost(true);
    try {
      const randomPostData = await GetRandomBlogPost();
      const jsonPostList = JSON.parse(randomPostData);
      setRandomPost(jsonPostList);
      setLoadingPost(false);
    } catch (error) {
      setLoadingPost(false);
      console.error('Error fetching the data:', error);
    }
  };

  const GetPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setpageContent(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  return (
    <><div>
      <Header />

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(htmlMinifierFAQ)}
        </script>
      </Helmet>

      <RandomContent />

            <div className="blog-area">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">{pageContent?.section1header}</a></h4>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          pageContent?.section1text && pageContent.section1text.trim() !== ""
                                            ? pageContent.section1text
                                            : `Optimize your HTML files with ease using Data Beautifier's Free HTML Minifier Online Tool. Our Best HTML Minifier Online Tool compresses your HTML data by removing unnecessary spaces, line breaks, and formatting, ensuring a smaller, faster, and cleaner file. Designed for simplicity, our Simple HTML Minifier Tool requires no technical expertise, making it perfect for developers and web designers alike. With the Easy HTML Minifier Tool, you can enhance your workflow in just a few clicks. Accessible anytime and completely free, Data Beautifier provides reliable results for all your HTML compression needs. Try it today!`,
                                      }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
     

      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up"
                data-aos-duration="2800">
                <div className="thumb">
                  <Inputs
                    value={inputData}
                    setValue={(val) => {
                      setInputData(val);
                      setIsError(false); // Reset error on change
                    }}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    isError={isError}
                    lineCol={inputLnCol}
                    setLineCol={setInputLnCol}
                    readOnly={false}
                    idPrefix="input" />
                </div>
              </div>
            </div>

            <ConversionActions
              tabSpace={tabSpace}
              setTabSpace={setTabSpace}
              handleConversion={handleConversion}
              outputData={outputData}
              randomPost={randomPost}
              loadingPost={loadingPost}
              handleBlogClick={handleBlogClick}
              buttonLabel="Minify HTML"
              iconClass="ri-exchange-line"
            />

            <div className="full-col col-lg-5 col-md-5">
              <div className="single-blog-inner" data-aos="fade-up"
                data-aos-duration="1200">
                <div className="thumb">
                  <Output
                    value={outputData}
                    setValue={setOutputData}
                    lineCol={outputLnCol}
                    setLineCol={setOutputLnCol}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    isError={isError}
                    idPrefix="output" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {pageContent?.section2text &&
        pageContent.section2text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800">
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section2text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
   

      <Footer />
    </>
  );
};

export default HtmlMinifier;
